import React from "react"
import PropTypes from "prop-types"

import id from "@irati/utils/id"
import DealList from "@irati-web/perks/src/components/DealList"
import {FormattedMessage} from "@irati/utils/lang"
import DEAL_PAGES from "@irati-web/perks/src/constants/dealPage"
import {H3} from "@irati/ui/src/Typography"

import NothingFound from "./NothingFound"
import DealBrandResults from "../DealBrandResults"

const Deals = (props) => {
  const {deals, page, dealBrands} = props
  const idNamespace = id("deals", props)
  return (
    <div id={idNamespace}>
      <DealBrandResults dealBrands={dealBrands} />
      {(deals.length <= 0 && <NothingFound id={idNamespace} />) || (
        <>
          <H3 marginBottom={2}>
            <FormattedMessage id="search.components.searchAllResults.deals.resultsCount" values={{count: deals.length}} />
          </H3>
          <DealList id={idNamespace} deals={deals} page={page} />
        </>
      )}
    </div>
  )
}

Deals.propTypes = {
  deals: PropTypes.array,
  page: PropTypes.oneOf(DEAL_PAGES.PAGES).isRequired
}
Deals.defaultProps = {
  deals: []
}

export default Deals
